import { render, staticRenderFns } from "./balanceslist.vue?vue&type=template&id=3961260c&"
import script from "./balanceslist.vue?vue&type=script&lang=js&"
export * from "./balanceslist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports